import type { ChoiceWithCount, ChoicesWithCountDto } from './choices.types';

type ParseChoicesWithCountForUI = (input: ChoicesWithCountDto | unknown) => ChoiceWithCount[];

const parseChoicesWithCountForUI: ParseChoicesWithCountForUI = raw => {
  if (!raw || typeof raw !== 'object') {
    return [];
  }

  // Guard: if the payload is an array, Object.entries would use "0","1",… as values
  // and produce chips/labels that start with a literal "0".
  if (Array.isArray(raw)) {
    return raw.flatMap(entry => {
      if (!entry || typeof entry !== 'object') return [];
      const row = entry as Record<string, unknown>;
      const value = row.value ?? row.id;
      if (value == null || value === '') return [];
      const label = row.label ?? row.name ?? value;
      const count = row.count ?? row.exercisesCount ?? 0;
      return [
        {
          value: String(value),
          label: String(label),
          count: typeof count === 'number' ? count : Number(count) || 0,
        },
      ];
    });
  }

  return Object.entries(raw as ChoicesWithCountDto).map(([value, entry]) => ({
    value,
    label: entry?.label ?? value,
    count: entry?.count ?? 0,
  }));
};

export { parseChoicesWithCountForUI };
